import router from '../../plugins/router'
import api from '../../api/api'

const state = () => ({
    splash: true,
    accessToPage: false,
});

const getters = {};

const actions = {
    async appInitialize({commit, rootState}) {

        //show splash till settings loaded
        commit('SET_SPLASH', true);

        // get user token
        const token = localStorage.getItem("userToken");

        // check token
        if (token === null) {
            // if token is empty show login page and hide splash
            if (router.currentRoute.path !== '/user/login') {
                commit('SET_LOGIN_REDIRECT_PATH', router.currentRoute.path, {root: true});
                await router.replace('/user/login');
            }
            commit('SET_SPLASH', false);

            return;
        } else {
            // if token exists, update token to global token variable
            // global token variable will be use in api calls
            commit('UPDATE_TOKEN', token, {root: true});
        }

        //if settings is empty, wait for settings to fetched from api
        if (rootState.questions == null) {
            const settings = await api.call('game2-settings');

            if (settings) {
                commit('SET_SETTINGS', settings, {root: true});
                commit('game/ADD_TO_QUESTIONS', settings['starterQuestions'], {root: true});
                commit('SET_SPLASH', false);
            }
        }

        //user has privileges to access the page
        commit('SET_ACCESS_TO_PAGE', true);

    },
    setAccessToPage({commit}, payload) {
        commit('SET_ACCESS_TO_PAGE', payload)
    },
};

const mutations = {
    SET_SPLASH(state, payload) {
        state.splash = payload;
    },
    SET_ACCESS_TO_PAGE(state, payload) {
        state.accessToPage = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};